module.exports = __webpack_public_path__ + "static/img/userinfo-grey-bg.3fb4c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member-system/userinfo-grey-bg.png
// module id = StzY
// module chunks = 212